
import { Product } from "@/models/base";
import { DossierConfigService, ProductService } from "@/services";
import Vue from "vue";
import { TranslateResult } from "vue-i18n";
import AppProductQuickEditPrice from "./ProductQuickEditPrice.vue";

export default Vue.extend({
	data(){
		return{
			amount: 0.0,
		};
	},
	props: {
		product: {
			type: Object as ()=>Product,
			required: true
		},
		category: {
			type: Number,
			required: true
		}
	},
	computed: {
		sellPriceName():string{
			return DossierConfigService.getSellCategories().getCategoryName(this.category);
		},
		title():TranslateResult{
			return this.$ct("edit-sell-price-inc-vat", {sellPriceName: this.sellPriceName});
		}
	},
	methods: {
		close(){
			this.$emit("close");
		},
		async save(value:number){
			await ProductService.setSellPriceIncVat(this.product.ID, this.category, value);
		},
		refresh(){
			this.$emit("refresh");
		}
	},
	created(){
		this.amount = (this.product[`SellPrice${this.category}WithVat` as any as keyof(Product)] as any as number);
	},
	components: {
		AppProductQuickEditPrice
	},
	i18nEx: {
		componentPrefix: "components.products"
	}
});
